import { MouseState, TouchConfig, ViewBoxConfig, ZoomConfig } from "./types"

export const DEFAULT_VIEWBOX_CONFIG: ViewBoxConfig = {
  desktop: { width: 1000, height: 1550 },
  mobilePortrait: { width: 1000, height: 2000 },
  mobileLandscape: { width: 800, height: 1500 }
}

export const DEFAULT_ZOOM_CONFIG: ZoomConfig = {
  desktop: 500,
  mobile: 500,
  default: 500
}

export const DEFAULT_TOUCH_CONFIG: TouchConfig = {
  dragFactor: 10,
  mobileOrientationZoomFactor: 7,
  mobileFloorplanDragSpeedFactorReduceBy: 10
}

export const DEFAULT_MOUSE_STATE: MouseState = {
  down: false,
  at: Date.now(),
  pageX: 0,
  pageY: 0
}

// eslint-disable-next-line no-shadow
export enum BookingHeaderColors {
  ZONE_TEXT = 'rgba(0, 0, 0, 0.68)',
  OCCUPANCY_TEXT = 'rgba(0, 0, 0, 0.48)',
}